import { PanelList } from "components/PanelList/PanelList";
import { CompactTournamentListItem } from "./CompactTournamentListItem";
import { Tournament } from "model/Tournament/Tournament";

interface Props {
  tournaments: Tournament[];
}

export const CompactTournamentList = ({ tournaments }: Props) => {
  return (
    <PanelList>
      {tournaments.map((t) => (
        <CompactTournamentListItem tournament={t} key={t.id} />
      ))}
    </PanelList>
  );
};
